import { useParams } from 'react-router-dom';
import { ArtifactsModule } from '../modules/artifacts';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function ScopeArtifactsPage(): JSX.Element {
  return (
    <StartupSubPageShell scopeSection="artifacts">
      {() => <ScopeArtifacts />}
    </StartupSubPageShell>
  );
}

function ScopeArtifacts(): JSX.Element | null {
  const { scopeId } = useParams<{ scopeId: string }>();
  if (!scopeId) return null;
  return (
    <ArtifactsModule owner={{ type: 'scope', scopeId }} loaderTestId="scope-artifacts-loader" />
  );
}
